"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgThumbsUpOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30.14 10.62l-.29-.62H22.3l.51-4.3a3.69 3.69 0 00-.57-2.84A4.92 4.92 0 0018.18 1h-2.13L16 2a11.57 11.57 0 01-1.86 5.39A16.22 16.22 0 0110.67 11H2v17h10v-2h13.46l.24-.14a11.73 11.73 0 005-7.06 14.75 14.75 0 00-.56-8.18zM10 26H4V13h6zm18.71-7.62A9.81 9.81 0 0124.88 24H12V12.5a18.3 18.3 0 003.79-4 13.56 13.56 0 002.1-5.5h.29a2.94 2.94 0 012.42 1c.18.26.33.48.23 1.47L20.05 12h8.45a13.24 13.24 0 01.21 6.38z" })));
}
exports.default = SvgThumbsUpOutline;
//# sourceMappingURL=ThumbsUpOutline.js.map